<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <TheLoader :active="kLoading"/>

      <div class="modal-window-header gray">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">
            <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg></span>
            <span v-if="this.kunstner.Idnr">Rediger kunstner/designer register</span>
            <span v-if="this.kunstnerIdentifier && !this.kunstner.Idnr">Laster kunstner/designer...</span>
            <span v-if="!this.kunstnerIdentifier">Ny kunstner/designer register</span>
          </h3>
        </div>

        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheTextInput containerClassName="cell medium-12" label="Navn (Etternavn, Fornavn)" name="Navn" v-model.trim="form.Navn" maxlength="50" required v-validate="'required|max:50'"/>
            <!-- <TheSwitchInput style="margin-top:0.2rem;" containerClassName="cell medium-4" label="Er kunstner" v-model="form.Erkunstner" labelTrue="Ja" labelFalse="Nei" trueValue="T" falseValue="F"/> -->
          </div>
        </fieldset>
      </div>

      <div class="modal-window-body">
        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheTextInput containerClassName="cell medium-6" label="Fødselsted" name="Fodested" v-model.trim="form.Fodested" maxlength="100" v-validate="'max:100'"/>
            <TheTextInput containerClassName="cell medium-6" label="Dødssted" name="Dodssted" v-model.trim="form.Dodssted" maxlength="100" v-validate="'max:100'"/>

            <TheIntegerInput containerClassName="cell medium-6" label="Fødselsår" name="Fodeaar" v-model.trim="form.Fodeaar" maxlength="4" v-validate="'integer|min:3|max:4|max_value:2100'"/>
            <TheIntegerInput containerClassName="cell medium-6" label="Dødsaar" name="Dodsaar" v-model.trim="form.Dodsaar" maxlength="4" v-validate="'integer|min:3|max:4|max_value:2100'"/>

            <TheTextInput containerClassName="cell medium-12" label="Periode" name="Periode" v-model.trim="form.Periode" maxlength="100" v-validate="'max:100'"/>
            <TheTextArea containerClassName="cell medium-12" label="Historie" name="Historie" v-model.trim="form.Historie" maxlength="2000" v-validate="'max:2000'" :rows="4"/>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

            <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Lagre</a>
            <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Lagrer...<span class="loader-spinner"></span></a>
            <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Lagre</a>

            <a v-if="!this.kunstner.has_object" href="javascript:;" @click="deleteButtonClick()" class="button primary submit large">Slette</a>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
import KunstnerService from '@/services/KunstnerService'
import bus from '@/plugins/event-bus'

export default {
  name: 'KunstnerFormModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunstner: {
      type: Object,
      required: false,
      default: function () {
        return {
          Idnr: null
        }
      }
    },
    kunstnerIdentifier: {
      type: [Number, String],
      required: false,
      default: null
    }
  },
  data () {
    return {
      form: {},
      kLoading: false
    }
  },
  created () {
    // Set form not submittable
    this.setFormLoading(true)

    if (!this.kunstner.Idnr && this.kunstnerIdentifier) {
      this.loadKunstner()
    } else {
      // Set defaults
      this.makeFormItem()
      this.setFormLoading(false)
    }
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  methods: {
    loadKunstner: function () {
      this.kLoading = true

      KunstnerService.view(this.kunstnerIdentifier)
        .then((response) => {
          // Set key/values to kunstner prop
          this.$helpers.setObjectValues(response.data, this.kunstner)

          // Then make form item
          this.makeFormItem()
          this.setFormLoading(false)
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunde ikke laste inn Kunstner')
          this.$emit('close')
        })
        .then(() => {
          this.kLoading = false
        })
    },
    makeFormItem: function () {
      let defaults = {
        Erkunstner: 'F'
      }

      // Apply default values
      this.$helpers.setObjectValues(defaults, this.kunstner)

      // Clone kunstner to the form object
      this.form = this._.cloneDeep(this.kunstner)
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.setFormLoading(false)
        this.$emit('close')
      }
    },
    deleteButtonClick: function () {
      this.deleteKunstner()
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            KunstnerService.save(this.kunstner.Idnr, this.form)
              .then((response) => {
                // Show success alert
                this.$helpers.showSuccessAlert('Kunstner er lagret')

                // Emit save ok event
                bus.$emit('kunstner-saved', response.data)

                this.$emit('close')
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    deleteKunstner: function () {
      this.setFormProcessing(true)

      KunstnerService.delete(this.kunstner.Idnr)
        .then((response) => {
          this.$helpers.showSuccessAlert('Slettet artist')
          // Emit submit search event
          bus.$emit('search-advanced-form')
          this.$emit('close')
        })
        .catch((error) => {
          // Put API errors into the error container
          this.$helpers.sendApiErrorsToValidator(error, this.errors)
          this.$helpers.showErrorAlert('Kan ikke slette artist')
        })
        .then(() => {
          this.setFormProcessing(false)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KunstnerFormModal.vue